import * as angular from "angular";
import {IController} from "angular";

export class FulfillmentLinesTableCtrl implements IController {

  infiniteScroll: any;
  isCollapse: boolean;
  selectedFulfillmentId: string;
  onOpen: Function;
  onDispatch: Function;

  /* @ngInject */
  constructor() {}

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLinesTable', {
    bindings: {
      infiniteScroll: '<',
      isCollapse: '<',
      selectedFulfillmentId: '<',
      onOpen: '&',
      onDispatch: '&'
    },
    template: require('./fulfillment-lines-table.html').default,
    controller: FulfillmentLinesTableCtrl
  });
